import { List, Set } from "immutable";
import { HttpResult } from 'widgets-for-react';
import { pushDatalayer } from "../../../../seo/datalayer";
import { httpResult } from "widgets-for-react";
import { getLangFromDocument } from "../../../utils/history";
import { htmlDecode } from "../../../utils/html";
import { linkWrapper } from "../../../utils/link";
import { PaginatedItem } from "../../../utils/pagination";
import { ParsedOverviewDetailItem } from "./overviewWidget.state";
import { recentNewsSrc, recentNewsSrcSet, searchSrc, searchSrcSet } from "../../../drupal/utils/imageSizes";
import { parseDrupalImageUrls } from "../../../drupal/utils/modernImage";

export const getSearchQueryFromUrl = () => {
    let params = (new URL(window.location.href)).searchParams;
    let searchQuery = params.get("searchQuery");

    return searchQuery || ""
}

export const loadOverviewItems = async (overviewItemsCacheKeyName: string, defaultPageSize:number, optionalParameters?: { key: string, value: string }[], kind?: 'page'|"block"): Promise<HttpResult<PaginatedItem<ParsedOverviewDetailItem> & { suggestions?: string[] }>> => {
    let params = (new URL(window.location.href)).searchParams;
    let paramsToSend: { query: { key: string, value: string[] }[] } = { query: [] }
    let keys = Set(Array.from(params.keys()))

    keys.map(k => {
        let valueToAdd: { key: string, value: string[] } = { key: k, value: [] }
        params.getAll(k).map((v, i) => {
            valueToAdd.value.push(v)
        })
        paramsToSend.query.push(valueToAdd)
    })

    if (optionalParameters) {
        optionalParameters.map(op => {
            let res = paramsToSend.query.find(q => q.key == op.key)
            if (res) {
                res.value.push(op.value)
            }
            else {
                paramsToSend.query.push({ key: op.key, value: [op.value] })
            }
        })
    }


    if(paramsToSend.query.find(o => o.key.toLocaleLowerCase() == "page_size") == undefined){
        paramsToSend.query.push({ key: "page_size", value: [defaultPageSize.toString()] })
    }

    if(paramsToSend.query.find(o => o.key.toLocaleLowerCase() == "page") == undefined){
        paramsToSend.query.push({ key: "page", value: ["0"] })
    }

    paramsToSend.query.push({ key: "kind", value: [overviewItemsCacheKeyName] })
    let headers = new Headers()
    headers.append('content-type', 'application/json')

    let response = await fetch(`/api/v1/Drupal/GetOverviewItems?lang=${getLangFromDocument()}`, {
        body: JSON.stringify(paramsToSend),
        method: "put",
        headers: headers
    })

    let responseDataPage = await response.json()

    let items: List<ParsedOverviewDetailItem> = List(responseDataPage.Items.map((responseData: any) => {
        let headerContent = JSON.parse(responseData.HeaderContent)

        const fieldMediaImage = (headerContent.field_introduction_image || [])[0]?.target.field_media_image[0]
        const fieldMediaSource = (headerContent.field_introduction_image || [])[0]?.target.field_source[0]
            ? headerContent.field_introduction_image[0]?.target.field_source
            : undefined
        const dpImages = fieldMediaImage
            ? parseDrupalImageUrls(fieldMediaImage, fieldMediaSource, (overviewItemsCacheKeyName == 'news' ? recentNewsSrcSet : searchSrcSet), (overviewItemsCacheKeyName == 'news' ? recentNewsSrc : searchSrc))?.image
            : undefined
        responseData.Tags = responseData?.TaxonomyTerms.map((t: any) => t.Name)
        responseData.Description = (headerContent.field_introduction || [])[0]?.value


        let responseDataMapped: ParsedOverviewDetailItem = {
            Title: htmlDecode(responseData.Title || ""),
            Tags: responseData.Tags || [],
            Description: responseData.Description || '',
            Link: responseData.Slug && linkWrapper({
                url: responseData.Slug ? '/' + responseData.Slug.replace(/^\/+/g, '') : '',
                title: responseData.Title ? responseData.Title : '',
            }),
            Kind: responseData.Kind,
            image: dpImages,
            Created: responseData.Created,
            LastUpdated: responseData.LastUpdated,
        }

        return responseDataMapped
    }))

    let searchQuery = paramsToSend.query.find(p => p.key.toLowerCase() == "searchquery")

    if (searchQuery && searchQuery.value.length > 0) {
        pushDatalayer({
            event: "event.gtm",
            category: "search",
            label: searchQuery.value[0],
            action: items.count() > 0 ? "result" : "no_result"
        })
    }

    let suggestions: string[] | undefined = undefined;
    try {
      suggestions = responseDataPage.Suggestions?.autocomplete?.[0]?.options?.map((o: any) => o.text) ?? undefined;
    } catch (e) {
      suggestions = undefined;
    }

    return httpResult.success({
        items: List(items),
        pager: {
            currentPage: responseDataPage.PageIndex,
            totalItems: responseDataPage.TotalCount,
            totalPages: responseDataPage.NumPages,
            itemsPerPage: responseDataPage.PageSize
        },
        suggestions
    })
}
